export class GmailMessageWithOption {
    constructor(
        public sendTo: string[],
        public subject: string,
        public body: string,
        public hasPastePixel: boolean,
        public formData?: FormData
    ){}
}
